import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useSelector } from 'react-redux';
import { server } from '../../server';
import { getStoredAuthToken } from '../../utils/authSession';
import RoomPostCard from './RoomPostCard';

const getCurrentProfile = () => sessionStorage.getItem('currentProfile') || 'User';

const getAuthHeaders = () => {
  const token = getStoredAuthToken();
  const headers = { 'current-profile': getCurrentProfile() };

  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  return headers;
};

const RoomPostsFeed = ({ roomId, refreshKey }) => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const currentProfile = useSelector((state) => state.user.currentProfile);

  useEffect(() => {
    let isMounted = true;

    const fetchRoomPosts = async () => {
      if (!roomId) {
        return;
      }

      setLoading(true);
      setError('');

      try {
        const response = await axios.get(`${server}/room/rooms/${roomId}/posts`, {
          withCredentials: true,
          headers: getAuthHeaders(),
        });

        if (isMounted) {
          setPosts(Array.isArray(response.data.posts) ? response.data.posts : []);
        }
      } catch (err) {
        if (isMounted) {
          setPosts([]);
          setError(err.response?.data?.message || 'Unable to load community posts right now.');
        }
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    fetchRoomPosts();

    return () => {
      isMounted = false;
    };
  }, [roomId, refreshKey, currentProfile]);

  if (loading) {
    return <div className="community-profile-empty-state">Loading community posts...</div>;
  }

  if (error) {
    return <div className="community-profile-empty-state">{error}</div>;
  }

  if (posts.length === 0) {
    return <div className="community-profile-empty-state">No posts yet.</div>;
  }

  return (
    <div className="room-posts-feed">
      {posts.map((post) => (
        <RoomPostCard key={post._id} roomId={roomId} post={post} />
      ))}
    </div>
  );
};

export default RoomPostsFeed;